<app-dialog-heading [heading]="'Emails'"></app-dialog-heading>

@if (isDataExist) {
  <ng-container [ngTemplateOutlet]="showCases"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="emptyEmailDataTable"></ng-container>
}

<ng-template #showCases>
  <div class="mat-elevation-z8 table-container">
    <table mat-table matSort multiTemplateDataRows
           [dataSource]="emailDataSource"
           (matSortChange)="sortData($event)">

      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <span class="table-icon-container">
          <!-- Send Email Icon -->
            @if (showIcon(row, IconName.Send)) {
              <mat-icon class="mat-primary-color hand-cursor font-medium"
                        matTooltip="SEND email to {{getToAddress(row)}}"
                        (click)="onClickToggleIcons($event, row)">
              send
            </mat-icon>
            }

            <!-- Duplicate Email Icon -->
            @if (row[tableColumns.IsSent]) {
              <!--Allow duplicate functionality for Emails -->
              <app-duplicate defaultIcon="redo"
                             tooltip="RESEND email"
                             [customCssClasses]="['hand-cursor', 'font-medium']"
                             (duplicateItem)="OnClickDuplicate($event, row)"></app-duplicate>
            }

            <!-- Send Email Confirmation Icons -->
            @if (row.sendEmailChecked) {
              <mat-icon class="mat-primary-color hand-cursor font-medium"
                        matTooltip="CONFIRM Send to {{getToAddress(row)}}"
                        (click)="onClickSendEmailConfirmed($event, row)">
              done
            </mat-icon>
              <mat-icon class="hand-cursor font-medium"
                        matTooltip="CANCEL Send"
                        color="warn"
                        (click)="onClickToggleIcons($event, row)">
              close
            </mat-icon>
            }

            <!-- Reset Email Icon -->
            @if (showIcon(row, IconName.Reset)) {
              <mat-icon class="mat-primary-color hand-cursor font-medium" matTooltip="RESET email"
                        (click)="onClickToggleResetEmailIcons($event, row)">
              restart_alt
            </mat-icon>
            }

            <!-- Reset Email Confirmation Icons -->

            @if (row.resetEmailConfirmation) {
              <mat-icon class="mat-primary-color hand-cursor font-medium"
                        matTooltip="CONFIRM Reset email {{row[tableColumns.EmailId]}}"
                        (click)="onClickResetEmailConfirmed($event, row)">
              done
            </mat-icon>
              <mat-icon class="hand-cursor font-medium"
                        matTooltip="CANCEL Reset"
                        color="warn"
                        (click)="onClickToggleResetEmailIcons($event, row)">
              close
            </mat-icon>
            }

            @if (row.emailSentBusyCounter > 0) {
              <mat-icon class="m-l-10">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
            }
          </span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.EmailId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
        <td *matCellDef="let row" mat-cell>{{ row[tableColumns.EmailId] }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.FromAddress">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>From</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.FromAddress]">
          {{ row[tableColumns.FromAddress] | truncateText: {sliceEnd: 30, append: '...'} }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.ToAddress">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>To</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.ToAddress]">
          <span class="table-icon-container">
          <ng-container>
            @if (!row[tableColumns.IsSent] && !row?.isEditEmail) {
              <mat-icon class="mat-primary-color hand-cursor font-medium"
                        matTooltip="UPDATE address"
                        (click)="onClickEditAddress($event, row)">
                edit
              </mat-icon>
            }
            @if (row?.isEditEmail) {
              <mat-form-field [subscriptSizing]="'dynamic'">
                <input [formControl]="emailOverrideFormControl" matInput/>
                <span matSuffix class="table-icon-container dual-icon-container">
                  <button mat-icon-button (click)="onClickCancelEditAddress($event, row)">
                  <mat-icon matTooltip="Cancel edit" class="cancel-edit-icon">
                    cancel
                  </mat-icon>
                    </button>
                  <button mat-icon-button (click)="onClickSaveAddress($event, row)">
                  <mat-icon class="table-icon" matTooltip="Save address">
                    save
                  </mat-icon>
                    </button>
                </span>
              </mat-form-field>
            } @else {
              <ng-container [ngTemplateOutlet]="displayAddress"></ng-container>
            }

            <ng-template #displayAddress>
              @if (!row?.editedToAddress) {
                <ng-container>{{
                    row[tableColumns.ToAddress] | truncateText: {
                      sliceEnd: 30,
                      append: '...'
                    }
                  }}
                </ng-container>
              } @else {
                <ng-container [ngTemplateOutlet]="showEditedAddress"></ng-container>
              }
              <ng-template #showEditedAddress>
                {{ row?.editedToAddress | truncateText: {sliceEnd: 30, append: '...'} }}
              </ng-template>
            </ng-template>

          </ng-container>
          </span>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CCAddress">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>CC</th>
        <td *matCellDef="let row" mat-cell [matTooltip]="row[tableColumns.CCAddress]">
          {{ row[tableColumns.CCAddress] | truncateText: {sliceEnd: 30, append: '...'} }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CommunicationTriggerType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Communication Type</th>
        <td *matCellDef="let row" mat-cell>{{ row[tableColumns.CommunicationTriggerType]?.name }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.TriggerId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Trigger ID</th>
        <td *matCellDef="let row" mat-cell>{{ row[tableColumns.TriggerId] }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.IsSent">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Sent</th>
        <td *matCellDef="let row" mat-cell> {{ row[tableColumns.IsSent] ? 'Y' : 'N' }}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.PdfReport">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Report</th>
        <td *matCellDef="let row" mat-cell>
          @if (row[tableColumns.TriggerId] && row['attachment']) {
            <mat-icon class="hand-cursor" (click)="onClickGeneratePdfReport($event, row)">
              picture_as_pdf
            </mat-icon>
          }
        </td>
      </ng-container>

      <!--Expanded Section -->
      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="emailDisplayedColumns.length" mat-cell>
          <div [@detailExpand]="row == emailExpandedRow ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>Triggered By: </b>{{row.createdBy}}<br>
            <b>Triggered At: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Sent By: </b>{{row.updatedBy}}<br>
            <b>Sent At: </b>{{row.updated | date: dateTimeFormat}}<br>
            <b>Validation Message: </b>{{ row.validationMessage }}<br>
            <b>BCC: </b>{{ row?.bccAddress }}<br>
            @if (row?.body) {
              <b>Email: </b><br/>
              <div class="email m-t-10 m-b-15">
                <b>Subject: </b>{{ row?.subject }}<br>
                <b>Message: </b> <br/>
                <div [innerHTML]="row.body"></div>
              </div>
            }
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="emailDisplayedColumns;" mat-header-row></tr>
      <tr class="row"
          mat-row
          *matRowDef="let row; columns: emailDisplayedColumns;"
          [class.expanded-row]="emailExpandedRow == row"
          (click)="onClickRow($event, row)">
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>
    </table>

    <mat-paginator #emailPaginator
                   [length]="emailTableControl.length" [pageIndex]="0"
                   [pageSizeOptions]="emailTableControl.pageSizeOptions"
                   [pageSize]="emailTableControl.pageSize"
                   (page)="pageChanged($event)">
    </mat-paginator>
  </div>
</ng-template>

<ng-template #emptyEmailDataTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No email data</label>
  </div>
</ng-template>
